import { createLogger } from "@effektify/logger";
const LOG_LEVEL = "warn";
let loggerInstance = null;
const useLogger = (scope = "", options = {}) => {
  if (loggerInstance) {
    return loggerInstance;
  }
  loggerInstance = createLogger("Data-Provider", scope, {
    level: LOG_LEVEL,
    ...options
  }).logger;
  return loggerInstance;
};
export {
  useLogger as default
};
